import {
    MTextField,
    ResponsiveFormContainer,
  } from "@app/components";
  
  const IsotoposForm = () => {
  
    return (
      <>
        <ResponsiveFormContainer columns={4}>
          <MTextField
            key={"codigo"}
            name={"codigo"}
            label={"Código"}
            type="text"
            fullWidth
            validation={{ required: `El campo codigo es requerido` }}
          />
          <MTextField
            key={"simbolo"}
            name={"simbolo"}
            label={"Símbolo"}
            type="text"
            fullWidth
            validation={{ required: `El campo simbolo es requerido` }}
          />
          <MTextField
            key={"masa"}
            name={"masa"}
            label={"Masa"}
            type="text"
            fullWidth
            validation={{ required: `El campo masa es requerido` }}
          />
          <MTextField
            key={"metaestable"}
            name={"metaestable"}
            label={"Metaestable"}
            type="text"
            fullWidth
            validation={{ required: `El campo metaestable es requerido` }}
          />
          <MTextField
            key={"cdes"}
            name={"cdes"}
            label={"cdes"}
            type="text"
            fullWidth
            validation={{ required: `El campo cdes es requerido` }}
          />
          <MTextField
            key={"gammades"}
            name={"gammades"}
            label={"gammades"}
            type="text"
            fullWidth
            validation={{ required: `El campo gammades es requerido` }}
          />
          <MTextField
            key={"ugammades"}
            name={"ugammades"}
            label={"ugammades"}
            type="text"
            fullWidth
            validation={{ required: `El campo ugammades es requerido` }}
          />
          <MTextField
            key={"factor351"}
            name={"factor351"}
            label={"factor351"}
            type="text"
            fullWidth
            validation={{ required: `El campo factor351 es requerido` }}
          />
          <MTextField
            key={"factor911"}
            name={"factor911"}
            label={"factor911"}
            type="text"
            fullWidth
            validation={{ required: `El campo factor911 es requerido` }}
          />
          <MTextField
            key={"nra"}
            name={"nra"}
            label={"nra"}
            type="text"
            fullWidth
            validation={{ required: `El campo nra es requerido` }}
          />
          <MTextField
            key={"origen"}
            name={"origen"}
            label={"origen"}
            type="text"
            fullWidth
            validation={{ required: `El campo origen es requerido` }}
          />
          <MTextField
            key={"periodo"}
            name={"periodo"}
            label={"periodo"}
            type="text"
            fullWidth
            validation={{ required: `El campo periodo es requerido` }}
          />
          <MTextField
            key={"uperiodo"}
            name={"uperiodo"}
            label={"uperiodo"}
            type="text"
            fullWidth
            validation={{ required: `El campo uperiodo es requerido` }}
          />
          <MTextField
            key={"activo"}
            name={"activo"}
            label={"activo"}
            type="text"
            fullWidth
            validation={{ required: `El campo activo es requerido` }}
          />
          <MTextField
            key={"energia"}
            name={"energia"}
            label={"energia"}
            type="text"
            fullWidth
            validation={{ required: `El campo energia es requerido` }}
          />
        </ResponsiveFormContainer>
      </>
    );
  };
  
  export default IsotoposForm;
  